import React, { useCallback } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import DownloadIcon from 'icons/Download.icon';
import TableControlButton from 'components/TableControlButton';
import TablePanelDropdown from 'components/TablePanelDropdown';
import { TablePanelDropdownRef } from 'components/TablePanelDropdown/TablePanelDropdown.component';
import useCallbackRef from 'hooks/useCallbackRef';
import { TableExportSelection } from 'models/TableExport';
import TableExportForm from './components/TableExportForm';

import './TableExportPanel.styles.scss';

type TableExportPanelProps = {
  className?: string;
  totalItems: number;
  pageItemsCount: number;
  totalPages: number;
  totalColumnsCount: number;
  visibleColumnsCount: number;
  isExporting?: boolean;
  onExport: (selection: TableExportSelection) => Promise<void> | void;
};

const TableExportPanel: React.FC<TableExportPanelProps> = (props) => {
  const {
    className,
    totalItems,
    pageItemsCount,
    totalPages,
    totalColumnsCount,
    visibleColumnsCount,
    isExporting,
    onExport,
  } = props;

  const { t } = useTranslation();

  const [panel, panelRef] = useCallbackRef<TablePanelDropdownRef>();

  const classes = classNames(
    'table-export-panel',
    'table-panel-dropdown--form-panel',
    className,
  );

  const onCancel = useCallback(() => panel?.close(), [panel]);

  return (
    <TablePanelDropdown
      ref={panelRef}
      className={classes}
      title={t('export')}
      trigger={
        <div className="table-panel-dropdown__trigger-wrapper">
          <TableControlButton
            icon={DownloadIcon}
            tooltip={t('export')}
            disabled={!totalItems}
          />
        </div>
      }
    >
      <TableExportForm
        totalItems={totalItems}
        pageItemsCount={pageItemsCount}
        totalPages={totalPages}
        totalColumnsCount={totalColumnsCount}
        visibleColumnsCount={visibleColumnsCount}
        isExporting={isExporting}
        onExport={onExport}
        onCancel={onCancel}
      />
    </TablePanelDropdown>
  );
};

export default TableExportPanel;
